import { render } from "./Doar.vue?vue&type=template&id=7f7c961a&ts=true"
import script from "./Doar.vue?vue&type=script&lang=ts"
export * from "./Doar.vue?vue&type=script&lang=ts"

import "./Doar.vue?vue&type=style&index=0&id=7f7c961a&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__